module.exports = __webpack_public_path__ + "static/CircularStd-Medium-4fcdd97fadc3a1d9887f816f2aa67f1d.otf";